import authService from "@/services/authService.js";

const state = {
  user: null,
};

const getters = {
  isAuthenticated: (state) => !!state.user,
  authUser: (state) => state.user,
};

const actions = {
  async login({ commit }, { loginId, password }) {
    await authService.login(loginId, password);
    const response = await authService.getMyInfo();
    commit("setUser", response.data.data);
  },
  async logout({ commit }) {
    try {
      await authService.logout();
    } catch (error) {
      // Session already expired/invalid — client should still clear local auth state
      if (!error.response || (error.response.status !== 401 && error.response.status !== 419)) {
        throw error;
      }
    } finally {
      commit("setUser", null);
    }
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
